<template>
  <slot v-if="loadable.isLoading" name="loading">
    <BaseLoaderWrapper :label="loadingLabel" />
  </slot>
  <slot v-else-if="loadable.isError" name="error">
    <p class="base-async-wrapper-error">{{ errorMessage }}</p>
  </slot>
  <slot v-else :data="loadable.data" />
</template>

<script lang="ts" setup generic="T">
  import { BaseLoaderWrapper } from '~/components/base-ui/loader'
  import type { Loadable } from '~/shared/types/loadable'
  import { messages } from '~/shared/const/messages'

  withDefaults(
    defineProps<{
      loadable: Loadable<T>
      loadingLabel?: string
      errorMessage?: string
    }>(),
    {
      loadingLabel: undefined,
      errorMessage: messages.errors.get,
    }
  )

  defineSlots<{
    default(props: { data: T }): unknown
    loading(): unknown
    error(): unknown
  }>()
</script>

<style lang="scss" scoped>
  .base-async-wrapper-error {
    font-size: 16px;
    line-height: 24px;
    margin: 0;
  }
</style>
